/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {  pagination,Table } from "antd";
import {onShowSizeChange,itemRender}from  '../Pagination'
import Header from '../Header';
import Sidebar from '../Sidebar';
import { blogimg10, imagesend, pdficon, pdficon3, pdficon4, plusicon, refreshicon, searchnormal, blogimg12,
     blogimg2, blogimg4, blogimg6, blogimg8,male,female} from '../imagepath';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { getdoctor } from '../../services/admin/doctor/doctor';
import { SearchOutlined } from '@ant-design/icons';

const DoctorList = () => {

    const [dataSource, setDataSource] = useState([]);
     const [loading, setLoading] = useState(true);
     const [selectedRowKeys, setSelectedRowKeys] = useState([]);


     const fetchDoctors = async () => {
         try {
           const result = await getdoctor();
           if (result.success) {
             // Transform the hospital data if needed to fit the table structure
             const formattedData = result.data.map((item, index) => ({
               id: item.id || index,
               parentId: item.parent_user_id,
               Name: item.name,
               middlename: item.middle_name,
               lastname: item.last_name,
               Email: item.email,
               mobile: item.mobile,
               designation: item.designation,
               qualification: item.qualification,
               speciality: item.speciality,
               mci_registration_number: item.mci_registration_number,
               date_of_birth: item.date_of_birth,
               doctor_types: item.doctor_types,
               module_permissions: item.module_permissions,
               gender: item.gender,
               address: item.address,
               city: item.city,
               state: item.state,
               country: item.country,
               pincode: item.pincode,
               hospital:item.hospital,
               status:item.status,
               
             }));
             console.log("Formatted Data:", formattedData);
             setDataSource(formattedData);
           } else {
             console.error("Error:", result.error || "Failed to fetch hospitals");
           }
         } catch (err) {
           console.error("Exception:", err.message);
         } finally {
           setLoading(false);
         }
       };
     
       useEffect(() => {
         fetchDoctors();
       }, []);

    const onSelectChange = (newSelectedRowKeys) => {
      console.log("selectedRowKeys changed: ", selectedRowKeys);
      setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
      };
      const onChange = (date, dateString) => {
        // console.log(date, dateString);
      };

  
    const columns = [
        {
            title: "Name",
            dataIndex: "Name",
            render: (text, record) => (
                <>
                    <h2 className="profile-image">
                        <Link to="#" className="avatar avatar-sm me-2">
                            
                            
                              <img
                                className="avatar-img rounded-circle"
                                src={record.gender == "male" ? male : female}
                                alt="User Image"
                            />
                        </Link>
                        <Link to="#">{record.Name}  {record.lastname}</Link>
                    </h2>

                </>
            ),
            // sorter: (a, b) => a.Name.length - b.Name.length
        },
        
        {
            title:"Mobile",
            dataIndex: "Mobile",
                //sorter: (a, b) => a.Mobile.length - b.Mobile.length,
                render: (text, record) => (
                    <>
                            <Link to="#">{record.mobile}</Link>
                    </>
                )
        }, {
            title:"Email",
            dataIndex: "Email",
                //sorter: (a, b) => a.Email.length - b.Email.length
        },
         {
            title:"Hospital",
            dataIndex: "hospital",
            render: (text, record) => (
                    <>
                            <Link to="#">{record.hospital.name}</Link>
                    </>
                )
                // sorter: (a, b) => a.Email.length - b.Email.length
        },
         {
            title:"Status",
            dataIndex: "status",
                // sorter: (a, b) => a.Email.length - b.Email.length
        },

        {
          title: "",
          dataIndex: "FIELD8",
          render: (text, record) => (
            <>
              <div className="text-end">
                <div className="dropdown dropdown-action">
                  <Link
                    to="#"
                    className="action-icon dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fas fa-ellipsis-v" />
                  </Link>
                  <div className="dropdown-menu dropdown-menu-end">
                    <Link className="dropdown-item" to="/doctorprofile" state={{ doctor: record }}>
                      <i className="fa-solid fa-user-doctor me-2" />
                      View Profile
                    </Link>
                    <Link className="dropdown-item" to="/editdoctor" state={{ doctor: record }}>
                      <i className="far fa-edit me-2" />
                      Edit
                    </Link>
                    <Link className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_patient">
                       <i className="fa fa-trash-alt m-r-5"></i> Delete</Link>
                  </div>
                </div>
              </div>
            </>
          ),
        },
    ]


  return (
    <>
     <Header /> 
    <Sidebar activeClassName='doctor'/> 
    <>
  <div className="page-wrapper">
    <div className="content">
      {/* Page Header */}
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/doctorlist">Doctors </Link>
            </li>
              <li className="breadcrumb-item">
                <i className="feather-chevron-right">
                  <FeatherIcon icon="chevron-right" />
                  </i>
              </li>
              <li className="breadcrumb-item active">Doctors List</li>
            </ul>
          </div>
        </div>
      </div>
      {/* /Page Header */}
      <div className="row">
        <div className="col-sm-12">
          <div className="card card-table show-entire">
            <div className="card-body">
              {/* Table Header */}
              <div className="page-table-header mb-2">
                <div className="row align-items-center">
                  <div className="col">
                    <div className="doctor-table-blk">
                      <h3>Doctors List</h3>
                      <div className="doctor-search-blk">
                        <div className="top-nav-search table-search-blk">
                          <form>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search here"
                            />
                            <Link className="btn" style={{color:"#2e37a4",fontWeight: "bold"}}>
                            <SearchOutlined style={{ fontSize: "18px",fontWeight: "bold" }}/>
                            </Link>
                          </form>
                        </div>
                        <div className="add-group">
                          <Link
                            to="/add-doctor"
                            className="btn btn-primary add-pluss ms-2"
                          >
                            <img src={plusicon} alt="#" />
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-primary doctor-refresh ms-2"
                          >
                            <img src={refreshicon} alt="#" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-auto text-end float-end ms-auto download-grp">
                    <Link to="#" className=" me-2">
                      <img src={pdficon} alt="#" />
                    </Link>
                    <Link to="#" className=" me-2">
                    </Link>
                    <Link to="#" className=" me-2">
                      <img src={pdficon3} alt="#" />
                    </Link>
                    <Link to="#">
                      <img src={pdficon4} alt="#" />
                    </Link>
                  </div> */}
                </div>
              </div>
              {/* /Table Header */}
              <div className="table-responsive doctor-list">
              <Table
                        pagination={{
                          total: dataSource.length,
                          showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          // showSizeChanger: true,
                           onShowSizeChange: onShowSizeChange,
                           itemRender: itemRender,
                           style: { paddingRight: "14px" },
                        }}
                        columns={columns}
                        dataSource={dataSource}
                        loading={loading}
                        rowSelection={rowSelection}
                        rowKey={(record) => record.id}
                        style={{
                          backgroundColor: '#f2f2f2', // Replace with your desired background color for the table
                        }}
                      />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
  <div id="delete_patient" className="modal fade delete-modal" role="dialog">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-body text-center">
          <img src={imagesend} alt="#" width={50} height={46} />
          <h3>Are you sure want to delete this ?</h3>
          <div className="m-t-20">
            {" "}
            <Link to="#" className="btn btn-white me-2" data-bs-dismiss="modal">
              Close
            </Link>
            <button type="submit" className="btn btn-danger">
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="delete_patient" className="modal fade delete-modal" role="dialog">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-body text-center">
          <img src={imagesend} alt="#" width={50} height={46} />
          <h3>Are you sure want to delete this ?</h3>
          <div className="m-t-20">
            {" "}
            <Link to="#" className="btn btn-white me-2" data-bs-dismiss="modal">
              Close
            </Link>
            <button type="submit" className="btn btn-danger">
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</>


    <>

</>

</>

  )
}

export default DoctorList;
